// extracted by mini-css-extract-plugin
export default {"project-size-preview":"ProjectSizePreview_project-size-preview__o-mlG"};